import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
export const PlayerContainer = styled.div `
    width: 100%;
    height: 100%;
    background: black;
    position: relative;
    overflow: hidden;
`;
PlayerContainer.displayName = 'PlayerContainer';
export const VideoContainer = styled.div.withConfig(testableStyledComponentConfig) `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    iframe {
        opacity: 0 !important;
    }
    .player-embedded-ui iframe {
        opacity: 1 !important;
    }
`;
VideoContainer.displayName = 'VideoContainer';
export const PlayerUI = styled.div `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: ${(props) => (props.isEmbeddedAdUiShown ? 'none' : 'auto')};
`;
PlayerUI.displayName = 'PlayerUI';
//# sourceMappingURL=index.js.map